import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormServiceService} from 'src/app/shared/services/dynamic-form-service.service';

@Component({
    selector: 'app-input-comp',
    templateUrl: './input-comp.component.html',
    styleUrls: ['./input-comp.component.scss'],
    standalone: false
})
export class InputCompComponent implements OnInit {

  constructor(private dynamicService: DynamicFormServiceService) { }
  field: FieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  ngOnInit() {
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
  }
}
